// Central UI-string dictionary for Pelangi Homestay.
// Two keys: id (Indonesian, default) and en (English).
// Keep keys stable — pages use t("nav.home") etc.
// CMS content (rooms, menu, attractions, faqs, testimonials, site.hero*, etc.)
// is translated via optional *_en fields on each item — see pickLang().

export const DICTIONARY = {
  id: {
    common: {
      bookNow: "Book Now",
      viewRooms: "Lihat Kamar",
      viewAll: "Lihat Semua",
      allQuestions: "Semua Pertanyaan",
      checkAvailability: "Cek Ketersediaan",
      ourStory: "Cerita Kami",
      sendMessage: "Kirim Pesan",
      sending: "Mengirim…",
      contactUs: "Hubungi Kami",
      backToBlog: "Kembali ke Blog",
      allArticles: "Semua Artikel",
      loading: "Memuat…",
      noArticles: "Belum ada artikel.",
      toggleMenu: "Buka menu",
      contactSuccess: "Terima kasih! Tim kami akan segera menghubungi Anda.",
      language: "Bahasa",
    },
    nav: {
      home: "Beranda",
      rooms: "Kamar",
      facilities: "Fasilitas",
      gallery: "Galeri",
      explore: "Explore Bedugul",
      restaurant: "Restoran",
      about: "Tentang",
      blog: "Blog",
      contact: "Kontak",
    },
    home: {
      aboutEyebrow: "Tentang kami",
      aboutTitle: "Rumah",
      aboutTitleItalic: "hangat",
      aboutTitleSuffix: "untuk perjalanan tenang.",
      aboutBody:
        "adalah keluarga kecil di Bedugul. Kami percaya liburan terbaik bukan tentang kemewahan, melainkan tentang kopi yang mengepul, percakapan yang tulus, dan pagi yang tak terburu-buru. Setiap kamar dirawat dengan detail sederhana namun konsisten — air panas yang selalu siap, sarapan hangat setiap pagi, dan staf lokal yang mengenal Bedugul luar dalam. Kami ada untuk tamu yang mencari jeda dari keramaian: pelancong yang datang untuk melihat kabut pagi di Danau Beratan, keluarga yang ingin anak-anaknya merasakan dinginnya dataran tinggi, atau siapa pun yang sekadar ingin tidur nyenyak setelah seharian menjelajah.",
      // "Tentang Bedugul" (2026-07-28, permintaan user - perluas konten homepage) - SENGAJA
      // tidak menyebut nama brand spesifik (dipakai bersama Pelangi & Harmoni), murni fakta
      // umum ttg kawasan Bedugul yang sama-sama relevan utk kedua properti.
      aboutAreaEyebrow: "Tentang Kawasan",
      aboutAreaTitle: "Mengenal",
      aboutAreaItalic: "Homestay Bedugul",
      aboutAreaBody: [
        "Bedugul adalah kawasan dataran tinggi di jantung Bali, mengelilingi Danau Beratan yang tenang dan sering berselimut kabut tipis di pagi hari. Berbeda dari suasana pantai di selatan Bali, udara di sini terasa sejuk sepanjang tahun — cocok bagi siapa pun yang ingin melarikan diri sejenak dari terik dan keramaian.",
        "Kawasan ini paling dikenal lewat Pura Ulun Danu Beratan, pura yang berdiri di tepi danau dan menjadi salah satu ikon Bali yang paling sering difoto — bahkan tampil di lembar uang kertas Rp 50.000. Tak jauh dari sana, Kebun Raya Bali menyimpan ribuan koleksi tanaman tropis dataran tinggi, sementara Pasar Candikuning menjual stroberi segar dan sayur mayur hasil kebun lokal setiap hari.",
        "Karena berada di jalur utama Denpasar–Singaraja, Bedugul juga menjadi persinggahan populer bagi pelancong yang menuju Bali utara, sekaligus tujuan akhir tersendiri bagi yang ingin liburan singkat namun berkesan di homestay Bedugul yang tenang.",
      ],
      roomsEyebrow: "Pilihan Kamar",
      roomsTitle: "Tempat",
      roomsItalic: "beristirahat",
      roomsSub: "Dua tipe akomodasi, masing-masing dengan karakternya sendiri.",
      roomsSubSingle: "Satu tipe kamar, dirawat dengan hati.",
      facilitiesEyebrow: "Fasilitas",
      facilitiesTitle: "Kenyamanan yang",
      facilitiesItalic: "menemani",
      // "Kenapa Memilih Kami" (2026-07-28) - rangkuman benefit dari fakta yang SUDAH ada
      // (FAQ breakfast/pembatalan/extra bed/parkir, facilityData air panas) - bukan klaim
      // baru, cuma ditegaskan ulang jadi ringkasan yang mudah dipindai tamu.
      whyEyebrow: "Kenapa Kami",
      whyTitle: "Alasan Tamu",
      whyItalic: "Kembali Lagi",
      whyList: [
        "Sarapan lokal hangat sudah termasuk setiap malam menginap — bukan biaya tambahan terpisah.",
        "Pembatalan gratis hingga 3 hari sebelum tanggal check-in, tanpa proses berbelit.",
        "Air panas 24 jam — kebutuhan penting di suhu dingin dataran tinggi Bedugul.",
        "Parkir gratis untuk mobil maupun motor, tanpa biaya tambahan.",
        "Tim lokal yang memahami Bedugul luar dalam, siap membantu setiap hari.",
      ],
      galleryEyebrow: "Galeri",
      galleryTitle: "Sudut",
      galleryItalic: "favorit",
      // (2026-08-13, bug nyata ditemukan Agus - "harmonihillsvillage.com yang tampil web
      // pelangi") - sebelumnya hardcode "Pelangi Homestay" walau string ini dipakai
      // bersama Harmoni juga (beda dari galleryTitle/aboutAreaBody dkk di file ini yang
      // SUDAH sengaja brand-neutral) - dibuat neutral juga supaya konsisten.
      gallerySub: "Sekilas suasana homestay dan Bedugul di sekitarnya.",
      exploreEyebrow: "Explore",
      exploreTitle: "Jelajahi",
      exploreItalic: "Bedugul",
      exploreSub:
        "Tempat-tempat favorit yang bisa dicapai dalam hitungan menit dari kamar Anda.",
      exploreIntro:
        "Semua daya tarik utama Bedugul berada dalam radius singkat dari homestay, cocok dijelajahi jalan kaki maupun naik motor sewaan. Mulai pagi dengan sarapan hangat, berjalan santai ke tepi danau, mampir ke pasar lokal untuk stroberi segar, lalu kembali beristirahat sebelum kabut sore turun.",
      // "Cara Menuju Lokasi" & "Tips Menginap" (2026-07-28) - fakta rute umum (bukan klaim
      // spesifik properti) & tips generik ttg kawasan, aman dipakai bersama Pelangi & Harmoni.
      directionsEyebrow: "Perjalanan",
      directionsTitle: "Cara Menuju",
      directionsItalic: "Lokasi",
      directionsBody: [
        "Bedugul dapat dicapai dengan mobil pribadi, taksi, maupun kendaraan sewaan dari Bandara Internasional Ngurah Rai atau pusat kota Denpasar, menyusuri jalur utama Denpasar–Singaraja menuju Bali utara. Perjalanan biasanya memakan waktu sekitar 2–2,5 jam tergantung kondisi lalu lintas, melewati Mengwi dan hamparan sawah berundak sebelum tanjakan mulai terasa dan suhu udara perlahan menurun.",
        "Jalan menuju kawasan ini sudah beraspal baik dan dilalui banyak kendaraan wisata, sehingga cukup nyaman digunakan siang maupun malam hari. Bagi yang datang dari arah Singaraja atau Lovina di Bali utara, homestay Bedugul juga bisa menjadi persinggahan nyaman di tengah perjalanan menuju Bali selatan.",
      ],
      tipsEyebrow: "Panduan",
      tipsTitle: "Tips Menginap di",
      tipsItalic: "Bedugul",
      tipsList: [
        "Bawa jaket atau pakaian hangat — suhu malam hari di Bedugul bisa turun cukup jauh, jauh lebih dingin dibanding kawasan pantai Bali.",
        "Datang atau bangun pagi hari untuk melihat Danau Beratan saat kabut belum terangkat — pemandangan yang paling difavoritkan wisatawan.",
        "Pesan lebih awal saat akhir pekan atau musim liburan sekolah — kamar di kawasan ini cepat penuh karena permintaan yang tinggi.",
        "Sempatkan mampir ke Pasar Candikuning untuk stroberi segar, sayur mayur, dan oleh-oleh khas dataran tinggi.",
        "Siapkan uang tunai secukupnya — sebagian usaha kecil di sekitar kawasan wisata belum menerima pembayaran digital.",
        "Konfirmasi jam kedatangan Anda lewat WhatsApp bila tiba di luar jam reception, supaya tetap bisa dilayani dengan lancar.",
        "Jangan lewatkan berjalan kaki santai di sekitar Kebun Raya Bali pada pagi hari — udaranya paling segar sebelum siang.",
        "Alokasikan waktu ekstra di perjalanan pulang menuju bandara, terutama saat jam sibuk di sekitar Denpasar.",
      ],
      testimonialsEyebrow: "Kata Tamu",
      testimonialsTitle: "Cerita",
      testimonialsItalic: "mereka",
      findEyebrow: "Temukan kami",
      findTitle: "Di jantung Bedugul.",
      findBody:
        "5 menit dari Pura Ulun Danu Beratan, 8 menit ke Kebun Raya Bali. Akses mudah lewat jalur utama Denpasar–Singaraja.",
      faqEyebrow: "FAQ",
      faqTitle: "Pertanyaan",
      faqItalic: "sering ditanya",
    },
    rooms: {
      eyebrow: "Rooms",
      title: "Pilih kamar",
      italic: "Anda",
      subtitle: "Dua tipe akomodasi, semuanya dirawat dengan hati.",
      subtitleSingle: "Satu tipe kamar, dirawat dengan hati.",
      policyTitle: "Kebijakan Umum",
      policy: [
        "Check-in mulai 14:00 WITA · Check-out 12:00 WITA",
        "Extra bed Rp 50.000 / malam termasuk sarapan",
        "Anak di bawah 6 tahun gratis tanpa extra bed",
        "Pembatalan gratis hingga 3 hari sebelum check-in",
      ],
      startFrom: "Mulai dari",
      perNight: "/ malam",
      viewDetails: "Lihat Foto & Fasilitas",
    },
    facilities: {
      eyebrow: "Facilities",
      title: "Kenyamanan yang",
      italic: "menemani",
      subtitle:
        "Semua yang Anda butuhkan untuk liburan tenang di dataran tinggi.",
    },
    facilityData: [
      { icon: "fa-wifi", title: "WiFi Cepat", desc: "Fiber optic di seluruh area." },
      { icon: "fa-mug-hot", title: "Air Panas 24 Jam", desc: "Selalu siap untuk pagi yang dingin." },
      { icon: "fa-tv", title: "Smart TV", desc: "Netflix & YouTube di setiap kamar." },
      { icon: "fa-utensils", title: "Breakfast Lokal", desc: "Menu hangat khas Bedugul." },
      { icon: "fa-tree", title: "Taman & Kebun", desc: "Sudut hijau untuk pagi tenang." },
      { icon: "fa-mountain", title: "View Pegunungan", desc: "Kabut pagi tepat di depan mata." },
      { icon: "fa-car", title: "Parkir Luas", desc: "Aman untuk mobil & motor." },
      { icon: "fa-headset", title: "Reception Ramah", desc: "Tim lokal siap membantu 07:00–22:00." },
    ],
    gallery: {
      eyebrow: "Gallery",
      title: "Sudut",
      italic: "Pelangi",
      subtitle:
        "Sekilas suasana kamar, taman, restoran, dan pemandangan sekitarnya.",
      categories: {
        Semua: "Semua",
        "Standard Room": "Standard Room",
        Cottage: "Cottage",
        Bathroom: "Kamar Mandi",
        Restaurant: "Restoran",
        Garden: "Taman",
        View: "Panorama",
        Lobby: "Lobi",
      },
    },
    explore: {
      eyebrow: "Explore",
      title: "Jelajahi",
      italic: "Bedugul",
      subtitle:
        "Destinasi favorit yang bisa dicapai dalam hitungan menit dari homestay.",
    },
    restaurant: {
      eyebrow: "Restaurant",
      title: "Cerita rasa",
      italic: "Bedugul",
      menuScript: "Menu",
      menuTitle: "Favorit tamu",
      hoursLabel: "Jam operasional",
    },
    about: {
      seoTitle: "Tentang Kami",
      seoDesc:
        "Pelangi Homestay Bedugul — penginapan keluarga sejak 2012 dengan 18 kamar (10 Standard + 8 Cottage) di jantung dataran tinggi Bali.",
      breadcrumb: "Tentang Kami",
      eyebrow: "Tentang Kami",
      title: "Rumah",
      titleItalic: "Hangat",
      titleSuffix: "di Jantung Bedugul sejak 2012.",
      storyHeading: "Cerita Kami",
      story: [
        "Pelangi Homestay didirikan pada tahun **2012** sebagai penginapan keluarga di kawasan Bedugul, Kecamatan Baturiti, Kabupaten Tabanan, Bali. Berawal dari beberapa kamar sederhana untuk wisatawan domestik, kami terus berkembang dengan mengutamakan pelayanan yang ramah, kebersihan, dan kenyamanan.",
        "Saat ini kami memiliki **18 kamar aktif** — terdiri dari **10 Standard Room** dan **8 Cottage Room** — yang dirancang untuk memberikan pengalaman menginap yang nyaman bagi pasangan, keluarga, maupun wisatawan yang ingin menikmati suasana sejuk Bedugul.",
        "Kami percaya bahwa pengalaman menginap terbaik bukan hanya tentang kamar, tetapi juga tentang keramahan, ketenangan, serta kemudahan menjelajahi destinasi wisata di sekitar Bedugul.",
      ],
      visionScript: "Visi",
      visionTitle: "Rumah kedua yang terpercaya.",
      visionBody:
        "Menjadi pilihan penginapan terpercaya di Bedugul dengan pelayanan yang hangat dan pengalaman menginap yang berkesan.",
      missionScript: "Misi",
      missionTitle: "Melayani dengan tulus.",
      mission: [
        "Memberikan pelayanan terbaik.",
        "Menjaga kebersihan dan kenyamanan seluruh area.",
        "Mendukung pariwisata dan komunitas lokal Bedugul.",
        "Menyediakan pengalaman menginap yang nyaman dan berkesan.",
      ],
      whyEyebrow: "Why choose us",
      whyTitle: "Kenapa memilih",
      whyItalic: "Pelangi?",
      whySub: "Beberapa alasan tamu kembali menginap di rumah kecil kami.",
      whyChooseUs: [
        { icon: "fa-bed", title: "18 Kamar Nyaman", desc: "10 Standard Room + 8 Cottage — semua dengan air panas, WiFi, dan Smart TV." },
        { icon: "fa-map-location-dot", title: "Lokasi Strategis", desc: "5 menit dari Pura Ulun Danu, 8 menit ke Kebun Raya Bali." },
        { icon: "fa-users", title: "Ramah Keluarga", desc: "Kapasitas 2 dewasa + 1 anak, taman aman untuk anak-anak." },
        { icon: "fa-wifi", title: "WiFi Gratis", desc: "Fiber optic di seluruh area, cocok untuk work-from-Bali." },
        { icon: "fa-utensils", title: "Sarapan Termasuk", desc: "Menu hangat khas dataran tinggi untuk mulai hari." },
        { icon: "fa-car", title: "Parkir Pribadi", desc: "Area parkir luas dan aman untuk mobil maupun motor." },
      ],
      values: [
        { icon: "fa-hand-holding-heart", title: "Tulus", desc: "Kami melayani seperti menerima keluarga sendiri." },
        { icon: "fa-leaf", title: "Lestari", desc: "Menggunakan produk lokal dan meminimalkan jejak plastik." },
        { icon: "fa-mug-hot", title: "Hangat", desc: "Setiap sudut dirancang untuk pagi yang lambat dan tenang." },
      ],
      facts: [
        { value: "2012", label: "Berdiri" },
        { value: "18", label: "Total Kamar" },
        { value: "10 + 8", label: "Standard + Cottage" },
        { value: "10+", label: "Tahun Melayani" },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Sapa",
      italic: "kami",
      subtitle:
        "Punya pertanyaan atau permintaan khusus? Tim kami dengan senang hati membantu.",
      visitScript: "Kunjungi",
      visitTitle: "Alamat",
      chatScript: "Chat",
      emailScript: "Email",
      emailTitle: "Kirim pesan",
      formName: "Nama",
      formEmail: "Email",
      formSubject: "Subjek",
      formMessage: "Pesan",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Pertanyaan",
      italic: "umum",
      subtitle:
        "Semoga jawaban di bawah ini membantu perencanaan liburan Anda.",
    },
    blog: {
      eyebrow: "Blog",
      title: "Cerita &",
      italic: "tips",
      subtitle: "Panduan wisata, itinerary, dan cerita dari Bedugul.",
      notFound: "Artikel tidak ditemukan.",
    },
    notFoundPage: {
      eyebrow: "404",
      title: "Halaman tidak ditemukan",
      body: "Halaman yang Anda cari sudah dipindahkan atau memang tidak pernah ada.",
      cta: "Kembali ke Beranda",
    },
    footer: {
      taglineSuffix:
        "— kabut pagi, kopi lokal, dan pelayanan tulus sejak 2012.",
      roomsInfo: "18 Kamar aktif · 10 Standard Room · 8 Cottage.",
      explore: "Jelajahi",
      information: "Informasi",
      legal: "Legal",
      contactHeading: "Hubungi",
      copyright: "Semua hak dilindungi.",
      madeWith: "Dibuat dengan",
      forBedugul: "untuk Bedugul.",
      links: {
        rooms: "Kamar",
        facilities: "Fasilitas",
        gallery: "Galeri",
        restaurant: "Restoran",
        explore: "Explore Bedugul",
        blog: "Blog",
        about: "Tentang Kami",
        paymentInfo: "Informasi Pembayaran",
        houseRules: "Peraturan Rumah",
        faq: "FAQ",
        contact: "Kontak",
        privacy: "Kebijakan Privasi",
        terms: "Syarat & Ketentuan",
        cancellation: "Kebijakan Pembatalan",
        refund: "Kebijakan Pengembalian",
      },
    },
    legal: {
      eyebrow: "Legal",
      ctaScript: "Siap menginap?",
      ctaTitle: "Reservasi lewat kanal resmi.",
      ctaBody:
        "Reservasi dilakukan melalui Booking Engine resmi untuk memastikan ketersediaan kamar dan keamanan transaksi.",
      lastUpdated: "Terakhir diperbarui",
    },
    whatsapp: {
      prefill:
        "Halo Pelangi Homestay, saya ingin bertanya tentang ketersediaan kamar.",
      label: "Chat WhatsApp",
    },
  },

  en: {
    common: {
      bookNow: "Book Now",
      viewRooms: "View Rooms",
      viewAll: "View All",
      allQuestions: "All Questions",
      checkAvailability: "Check Availability",
      ourStory: "Our Story",
      sendMessage: "Send Message",
      sending: "Sending…",
      contactUs: "Contact Us",
      backToBlog: "Back to Blog",
      allArticles: "All Articles",
      loading: "Loading…",
      noArticles: "No articles yet.",
      toggleMenu: "Toggle menu",
      contactSuccess: "Thank you! Our team will contact you shortly.",
      language: "Language",
    },
    nav: {
      home: "Home",
      rooms: "Rooms",
      facilities: "Facilities",
      gallery: "Gallery",
      explore: "Explore Bedugul",
      restaurant: "Restaurant",
      about: "About",
      blog: "Blog",
      contact: "Contact",
    },
    home: {
      aboutEyebrow: "About us",
      aboutTitle: "A",
      aboutTitleItalic: "warm",
      aboutTitleSuffix: "home for a slow journey.",
      aboutBody:
        "is a small family in Bedugul. We believe the best holidays are not about luxury, but about steaming coffee, honest conversations, and unhurried mornings. Every room is looked after with simple, consistent details — hot water always ready, a warm breakfast every morning, and local staff who know Bedugul inside out. We're here for guests looking for a break from the crowds: travelers coming to see the morning mist over Lake Beratan, families wanting their kids to feel the highland chill, or anyone who just wants a good night's sleep after a day of exploring.",
      aboutAreaEyebrow: "About the Area",
      aboutAreaTitle: "Getting to know",
      aboutAreaItalic: "Bedugul Homestay",
      aboutAreaBody: [
        "Bedugul is a highland region in the heart of Bali, surrounding the calm, often mist-covered Lake Beratan. Unlike the beach atmosphere of southern Bali, the air here stays cool year-round — perfect for anyone wanting a break from the heat and crowds.",
        "The area is best known for Ulun Danu Beratan Temple, standing at the lake's edge and one of Bali's most photographed icons — it even appears on the Rp 50,000 banknote. Nearby, Bali Botanic Garden holds thousands of highland tropical plant species, while Candikuning Market sells fresh strawberries and local produce every day.",
        "Sitting on the main Denpasar–Singaraja road, Bedugul is also a popular stopover for travelers heading to northern Bali, as well as a destination in its own right for a short but memorable stay at a quiet Bedugul homestay.",
      ],
      roomsEyebrow: "Our Rooms",
      roomsTitle: "A place to",
      roomsItalic: "rest",
      roomsSub: "Two room types, each with its own character.",
      roomsSubSingle: "One room type, cared for with heart.",
      facilitiesEyebrow: "Facilities",
      facilitiesTitle: "Comforts that",
      facilitiesItalic: "keep you company",
      whyEyebrow: "Why Choose Us",
      whyTitle: "Why Guests",
      whyItalic: "Come Back",
      whyList: [
        "Warm local breakfast is included every night you stay — not a separate add-on cost.",
        "Free cancellation up to 3 days before your check-in date, no complicated process.",
        "Hot water available 24 hours — essential in Bedugul's cool highland temperatures.",
        "Free parking for both cars and motorbikes, at no extra charge.",
        "A local team who knows Bedugul inside and out, ready to help every day.",
      ],
      galleryEyebrow: "Gallery",
      galleryTitle: "Favourite",
      galleryItalic: "corners",
      gallerySub: "A glimpse of the homestay and Bedugul around us.",
      exploreEyebrow: "Explore",
      exploreTitle: "Discover",
      exploreItalic: "Bedugul",
      exploreSub:
        "Beloved places just minutes away from your room.",
      exploreIntro:
        "Every major Bedugul attraction sits within a short radius of the homestay, easy to explore on foot or by rented motorbike. Start the morning with a warm breakfast, take a relaxed walk to the lakeside, stop by the local market for fresh strawberries, then head back to rest before the afternoon mist rolls in.",
      directionsEyebrow: "Getting Here",
      directionsTitle: "How to Reach",
      directionsItalic: "Bedugul",
      directionsBody: [
        "Bedugul is reachable by private car, taxi, or rental vehicle from Ngurah Rai International Airport or central Denpasar, following the main Denpasar–Singaraja road toward northern Bali. The drive usually takes around 2–2.5 hours depending on traffic, passing through Mengwi and terraced rice fields before the road starts climbing and the air gradually cools.",
        "The road into the area is well paved and used by plenty of tour vehicles, making it comfortable to travel by day or night. For those coming from Singaraja or Lovina in northern Bali, a Bedugul homestay also makes a convenient stopover on the way to southern Bali.",
      ],
      tipsEyebrow: "Guide",
      tipsTitle: "Tips for Staying in",
      tipsItalic: "Bedugul",
      tipsList: [
        "Bring a jacket or warm clothing — nighttime temperatures in Bedugul can drop noticeably lower than Bali's coastal areas.",
        "Arrive or wake up early to see Lake Beratan before the morning mist lifts — travelers' favorite view.",
        "Book ahead on weekends or school holidays — rooms in the area fill up fast due to high demand.",
        "Make time to visit Candikuning Market for fresh strawberries, local produce, and highland souvenirs.",
        "Carry some cash — many small local businesses near the attractions don't yet accept digital payments.",
        "Confirm your arrival time via WhatsApp if you're arriving outside reception hours, so you can still be served smoothly.",
        "Don't skip a relaxed morning walk around Bali Botanic Garden — the air is freshest before midday.",
        "Allow extra travel time on the way back to the airport, especially during peak hours around Denpasar.",
      ],
      testimonialsEyebrow: "Guest Words",
      testimonialsTitle: "Their",
      testimonialsItalic: "stories",
      findEyebrow: "Find us",
      findTitle: "In the heart of Bedugul.",
      findBody:
        "5 minutes from Ulun Danu Beratan Temple, 8 minutes to Bali Botanic Garden. Easy access via the main Denpasar–Singaraja road.",
      faqEyebrow: "FAQ",
      faqTitle: "Frequently",
      faqItalic: "asked",
    },
    rooms: {
      eyebrow: "Rooms",
      title: "Choose your",
      italic: "room",
      subtitle: "Two room types, both cared for with heart.",
      subtitleSingle: "One room type, cared for with heart.",
      policyTitle: "General Policy",
      policy: [
        "Check-in from 14:00 WITA · Check-out by 12:00 WITA",
        "Extra bed Rp 50,000 / night incl. breakfast",
        "Children under 6 stay free (no extra bed)",
        "Free cancellation up to 3 days before check-in",
      ],
      startFrom: "From",
      perNight: "/ night",
      viewDetails: "View Photos & Facilities",
    },
    facilities: {
      eyebrow: "Facilities",
      title: "Comforts that",
      italic: "keep you company",
      subtitle:
        "Everything you need for a peaceful highland getaway.",
    },
    facilityData: [
      { icon: "fa-wifi", title: "Fast WiFi", desc: "Fiber optic across the whole property." },
      { icon: "fa-mug-hot", title: "24-hour Hot Water", desc: "Always ready for cold mornings." },
      { icon: "fa-tv", title: "Smart TV", desc: "Netflix & YouTube in every room." },
      { icon: "fa-utensils", title: "Local Breakfast", desc: "Warm dishes typical of Bedugul." },
      { icon: "fa-tree", title: "Garden & Green", desc: "Quiet green corners for slow mornings." },
      { icon: "fa-mountain", title: "Mountain View", desc: "Morning mist right in front of you." },
      { icon: "fa-car", title: "Ample Parking", desc: "Safe for cars & motorbikes." },
      { icon: "fa-headset", title: "Friendly Reception", desc: "Local team on hand 07:00–22:00." },
    ],
    gallery: {
      eyebrow: "Gallery",
      title: "Pelangi",
      italic: "moments",
      subtitle:
        "A glimpse of the rooms, garden, restaurant, and views around us.",
      categories: {
        Semua: "All",
        "Standard Room": "Standard Room",
        Cottage: "Cottage",
        Bathroom: "Bathroom",
        Restaurant: "Restaurant",
        Garden: "Garden",
        View: "View",
        Lobby: "Lobby",
      },
    },
    explore: {
      eyebrow: "Explore",
      title: "Discover",
      italic: "Bedugul",
      subtitle:
        "Beloved destinations within minutes of the homestay.",
    },
    restaurant: {
      eyebrow: "Restaurant",
      title: "Flavours of",
      italic: "Bedugul",
      menuScript: "Menu",
      menuTitle: "Guest favourites",
      hoursLabel: "Opening hours",
    },
    about: {
      seoTitle: "About Us",
      seoDesc:
        "Pelangi Homestay Bedugul — family-run since 2012 with 18 rooms (10 Standard + 8 Cottage) in the heart of the Balinese highlands.",
      breadcrumb: "About Us",
      eyebrow: "About Us",
      title: "A",
      titleItalic: "warm",
      titleSuffix: "home in the heart of Bedugul since 2012.",
      storyHeading: "Our Story",
      story: [
        "Pelangi Homestay was founded in **2012** as a family-run inn in Bedugul, Baturiti sub-district, Tabanan Regency, Bali. Starting with a few simple rooms for domestic travellers, we have grown steadily while keeping friendly service, cleanliness, and comfort at the heart of what we do.",
        "Today we operate **18 active rooms** — **10 Standard Rooms** and **8 Cottage Rooms** — designed to give couples, families, and travellers a comfortable stay while enjoying the cool air of Bedugul.",
        "We believe the best stay isn't just about the room, but about warmth, quiet, and easy access to the beautiful destinations around Bedugul.",
      ],
      visionScript: "Vision",
      visionTitle: "A trusted second home.",
      visionBody:
        "To be the trusted highland stay in Bedugul, delivering warm service and memorable experiences.",
      missionScript: "Mission",
      missionTitle: "Serving with heart.",
      mission: [
        "Deliver our very best service.",
        "Keep every corner clean and comfortable.",
        "Support Bedugul's tourism and local community.",
        "Provide a comfortable and memorable stay.",
      ],
      whyEyebrow: "Why choose us",
      whyTitle: "Why choose",
      whyItalic: "Pelangi?",
      whySub: "A few reasons guests keep coming back to our small home.",
      whyChooseUs: [
        { icon: "fa-bed", title: "18 Comfortable Rooms", desc: "10 Standard + 8 Cottage — all with hot water, WiFi, and Smart TV." },
        { icon: "fa-map-location-dot", title: "Strategic Location", desc: "5 min to Ulun Danu Temple, 8 min to the Botanic Garden." },
        { icon: "fa-users", title: "Family Friendly", desc: "Capacity 2 adults + 1 child, safe garden for children." },
        { icon: "fa-wifi", title: "Free WiFi", desc: "Fiber optic across the property, great for work-from-Bali." },
        { icon: "fa-utensils", title: "Breakfast Included", desc: "Warm highland dishes to start your day." },
        { icon: "fa-car", title: "Private Parking", desc: "Ample, safe parking for cars and bikes." },
      ],
      values: [
        { icon: "fa-hand-holding-heart", title: "Sincere", desc: "We serve as if welcoming our own family." },
        { icon: "fa-leaf", title: "Sustainable", desc: "Local products and less plastic where we can." },
        { icon: "fa-mug-hot", title: "Warm", desc: "Every corner designed for a slow, quiet morning." },
      ],
      facts: [
        { value: "2012", label: "Established" },
        { value: "18", label: "Total Rooms" },
        { value: "10 + 8", label: "Standard + Cottage" },
        { value: "10+", label: "Years of Service" },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Say",
      italic: "hello",
      subtitle:
        "Questions or a special request? Our team is glad to help.",
      visitScript: "Visit",
      visitTitle: "Address",
      chatScript: "Chat",
      emailScript: "Email",
      emailTitle: "Drop a note",
      formName: "Name",
      formEmail: "Email",
      formSubject: "Subject",
      formMessage: "Message",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Common",
      italic: "questions",
      subtitle: "Hopefully these answers help you plan your stay.",
    },
    blog: {
      eyebrow: "Blog",
      title: "Stories &",
      italic: "tips",
      subtitle: "Travel guides, itineraries, and stories from Bedugul.",
      notFound: "Article not found.",
    },
    notFoundPage: {
      eyebrow: "404",
      title: "Page not found",
      body: "The page you're looking for has moved or never existed.",
      cta: "Back to Home",
    },
    footer: {
      taglineSuffix:
        "— morning mist, local coffee, honest service since 2012.",
      roomsInfo: "18 active rooms · 10 Standard · 8 Cottage.",
      explore: "Explore",
      information: "Information",
      legal: "Legal",
      contactHeading: "Contact",
      copyright: "All rights reserved.",
      madeWith: "Made with",
      forBedugul: "for Bedugul.",
      links: {
        rooms: "Rooms",
        facilities: "Facilities",
        gallery: "Gallery",
        restaurant: "Restaurant",
        explore: "Explore Bedugul",
        blog: "Blog",
        about: "About Us",
        paymentInfo: "Payment Information",
        houseRules: "House Rules",
        faq: "FAQ",
        contact: "Contact",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions",
        cancellation: "Cancellation Policy",
        refund: "Refund Policy",
      },
    },
    legal: {
      eyebrow: "Legal",
      ctaScript: "Ready to stay?",
      ctaTitle: "Reserve through the official channel.",
      ctaBody:
        "Reservations are made through the official Booking Engine to guarantee availability and secure transactions.",
      lastUpdated: "Last updated",
    },
    whatsapp: {
      prefill:
        "Hello Pelangi Homestay, I'd like to ask about room availability.",
      label: "WhatsApp Chat",
    },
  },
};

// Deep-key lookup, e.g. t("nav.home") or t("about.story.0")
export function tGet(dict, key) {
  return key.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), dict);
}
